import get from 'lodash/get';
import featureFlags from '@/store/modules/featureFlags';
import Metrics from './Metrics.vue';
import Platform from './Platform/Platform.router';
import Customers from './Customers/Customers.router';
import Campaign from './Campaign/Campaign.router';
import Agents from './Agents/Agents.router';
import Insights from './Insights/Insights.router';
import Assist from './Assist/Assist.router';
import SmartAssist from './SmartAssist/SmartAssist.router';

const showSmartAssistMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_SMART_ASSIST_METRICS', false);
const showCampaignMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_CAMPAIGN_METRICS', false);

const rootRoute = {
  path: '/metrics',
  name: 'Metrics',
  component: Metrics,
  meta: {
    auth: true,
  },
};
const childRoutes =
  [
    Platform,
    Customers,
    Agents,
    Insights,
    Assist,
    ...(showSmartAssistMetrics ? [SmartAssist] : []),
    ...(showCampaignMetrics ? [Campaign] : []),
  ];

export default {
  ...rootRoute,
  children: childRoutes,
};
